<template>
  <div class="admin admin-public-part-lot">
    <p class="admin-title a-flex-start a-align-items-center">
      {{$t('form.retend.lot-overview.title')}}
    </p>

    <div class="a-tab" id="accordion-tab">
      <div class="a-tab__control u-margin-b-24">
        <router-link to="overview" tag="button" type="button" class="a-tab__btn" active-class="a-active " >{{$t('form.lot.basic-data')}}</router-link>
        <router-link to="specification" tag="button" type="button" class="a-tab__btn" active-class="a-active">{{$t('form.lot.specification')}}</router-link>
      </div>

      <div class="collapse" :class="{'show': showOverview}">
        <form class="human-data">
          <overview :lot="lot"
                    :retend="retend"
                    v-if="retend">
          </overview>
        </form>
      </div>

      <div class="collapse" :class="{'show': showSpecification}">
        <form class="human-data">
          <specification :lot="lot"
                         :retend="retend"
                         v-if="retend && showSpecification">
          </specification>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
  import Overview from "./Overview";
  import Specification from "./Specification";

  export default {
    components: {
      Specification,
      Overview
    },

    computed: {
      showOverview() {
        return this.$route.params.tab === 'overview'
      },

      showSpecification() {
        return this.$route.params.tab === 'specification'
      },

      lotId() {
        return +this.$route.params.lotId;
      },

      retendNum() {
        return +this.$route.params.retendNum;
      },

      retend() {
        return this.$store.getters.retend(this.lotId, this.retendNum);
      },

      lot() {
        return this.$store.getters.lot(this.lotId);
      }
    },

    async created() {
      this.runBlockerAction(async () => {
        try {
          await this.$store.dispatch('fetchRetend', { lotId: this.lotId, retendNum: this.retendNum });
        }
        catch(e) {
          console.error('failed fetching retend', e);
          this.globalErrorHandler(e);
        }
      })
    }
  }
</script>

<style scoped lang="scss">
  .a-tab__btn {
    color: #4C4C4C;
    border-bottom: 1px solid transparent;
  }

  .a-tab__btn.a-active {
    color: #E30613;
    border-bottom: 1px solid #E30613;
  }
</style>
